import _ from 'lodash'
import Backbone from 'backbone'

/**
 * Class to manage the queue of dataset/chart queries to be made from a dashboard.
 */
class QueryQueue {
	constructor () {
		this.byDatasetId = {}
	}

	/**
	 * Add a dataset to the queue to be queried
	 *
	 * @param {Integer} datasetId
	 *
	 * @param {WidgetView[]|ALL} [includeViews] - Array of views to include in
	 * the query. If ALL is passed, all views for the dataset will be queried
	 *
	 * @param {WidgetView[]} [excludeViews] - Array of views to exclude from the
	 * query. These will be excluded even if includeViews is set to ALL
	 */
	add (datasetId, { includeViews, excludeViews }) {
		let alreadyQueued = this.byDatasetId[datasetId]
		if (!alreadyQueued) {
			this.byDatasetId[datasetId] = alreadyQueued = {
				includeViews: [],
				excludeViews: []
			}
		}

		if (includeViews === ALL) {
			// If querying for all widgets using this dataset, no need to keep
			// track of them
			alreadyQueued.includeViews = ALL
		} else {
			// Only need to add individual items if not already set to ALL
			if (alreadyQueued.includeViews !== ALL) {
				let alreadyQueuedCids = _.map(alreadyQueued.includeViews, 'cid')

				includeViews.forEach(v => {
					// Only add views once
					if (!_.includes(alreadyQueuedCids, v.cid)) {
						alreadyQueued.includeViews.push(v)
					}
				})
			}
		}

		_(excludeViews)
			.filter(v => !_.includes(alreadyQueued.excludeViews, v))
			.forEach(v => alreadyQueued.excludeViews.push(v))

		this.countdown()
	}

	countdown () {
		if (!this.timeoutId) {
			// No need to wait long, just giving the event loop time to clear
			this.timeoutId = setTimeout(this.launch.bind(this), 0)
		}
	}

	launch () {
		delete this.timeoutId
		this.trigger('query', this.byDatasetId)
		this.byDatasetId = {}
	}
}

const ALL = { all: true }

_.extend(QueryQueue.prototype, Backbone.Events)

export default QueryQueue
export { ALL }

QueryQueue.__filename__ = 'dashboards/widgets/query-queue.js'
